<script setup>
import { inject, computed } from 'vue'
import aquariusIcon from '@/assets/svg/zodiac/aquarius.svg'
import ariesIcon from '@/assets/svg/zodiac/aries.svg'
import cancerIcon from '@/assets/svg/zodiac/cancer.svg'
import capricornIcon from '@/assets/svg/zodiac/capricorn.svg'
import geminiIcon from '@/assets/svg/zodiac/gemini.svg'
import leoIcon from '@/assets/svg/zodiac/leo.svg'
import libraIcon from '@/assets/svg/zodiac/libra.svg'
import piscesIcon from '@/assets/svg/zodiac/pisces.svg'
import sagittariusIcon from '@/assets/svg/zodiac/sagittarius.svg'
import scorpioIcon from '@/assets/svg/zodiac/scorpio.svg'
import taurusIcon from '@/assets/svg/zodiac/taurus.svg'
import virgoIcon from '@/assets/svg/zodiac/virgo.svg'

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const zodiacIcons = computed(() =>
  new Map([
    ['aries', ariesIcon],
    ['taurus', taurusIcon],
    ['gemini', geminiIcon],
    ['cancer', cancerIcon],
    ['leo', leoIcon],
    ['virgo', virgoIcon],
    ['libra', libraIcon],
    ['scorpio', scorpioIcon],
    ['sagittarius', sagittariusIcon],
    ['capricorn', capricornIcon],
    ['aquarius', aquariusIcon],
    ['pisces', piscesIcon]
  ])
)

const checkSubscription = inject('checkSubscription')
</script>

<template>
  <div
    class="flex gap-1 items-center"
    :class="{ 'blur-md select-none py-2': checkSubscription(item) }">
    <img
      v-if="item.value && zodiacIcons.get(item.value.toLowerCase())"
      class="w-4 h-4"
      :src="zodiacIcons.get(item.value.toLowerCase())"
      :alt="item.value">

    <span class="text-sm text-gray-500 not-italic capitalize">
      {{ checkSubscription(item) ? 'Secret text' : item.value }}
    </span>
  </div>
</template>